import { useMutation } from "@shared/lib/hooks";
import { BriefService } from "../services/brief.service";
import { IEditBriefPayment } from "@shared/lib/types/briefPayment";
import { ToastService } from "@shared/lib/services";
import {
  BRIEF_PAYMENT_QUERY_KEY,
  BRIEF_PAYMENT_FACETS_QUERY_KEY,
  BRIEF_PAYMENT_AGGREGATION_QUERY_KEY,
  BRIEF_TOTAL_AGGREGATION_QUERY_KEY,
} from "../constants";

export function useEditBriefPayment() {
  const {
    mutate: edit,
    isLoading: isEditing,
    isSuccess: isEdited,
  } = useMutation({
    mutationFn: (data: IEditBriefPayment) =>
      BriefService.editBriefPayment(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      ToastService.success("Payment updated successfully");
      c.invalidateQueries({ queryKey: BRIEF_PAYMENT_QUERY_KEY });
      c.invalidateQueries({ queryKey: BRIEF_PAYMENT_FACETS_QUERY_KEY });
      c.invalidateQueries({ queryKey: BRIEF_PAYMENT_AGGREGATION_QUERY_KEY });
      c.invalidateQueries({ queryKey: BRIEF_TOTAL_AGGREGATION_QUERY_KEY });
    },
  });

  return {
    edit,
    isEditing,
    isEdited,
  };
}
